import { css } from 'lit'

export const mainStyles = css`
    @import url('https://unpkg.com/line-awesome@1.3.0/dist/line-awesome/css/line-awesome.min.css');
    vaadin-button {
        cursor: pointer;
    }

    /* The header owns its own hairline, so drop the navbar's. */
    vaadin-app-layout::part(navbar) {
        border-bottom: 0;
    }

    /* App shell: 115px header, logo + account on top, tabs along the bottom edge
       (STYLE.html §07). Brand gradient strip along the very top. */
    header {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: var(--kop-header-height);
        padding: 18px var(--kob-space-6) 0 var(--kob-space-6);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: var(--kob-surface-0);
        border-bottom: 1px solid var(--kob-line-200);
    }

    header::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: var(--kob-grad-warm, linear-gradient(90deg, #f96813 0%, #fbb040 100%));
        z-index: 1;
    }

    .app-header-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .app-logo {
        display: flex;
        align-items: center;
        gap: 10px;
        color: var(--kob-ink-900);
    }

    .app-logo svg {
        display: block;
    }

    .app-logo .word {
        font-size: 1.1rem;
        font-weight: 700;
        letter-spacing: -0.01em;
    }

    .app-account {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 0.85rem;
        color: var(--kob-ink-800);
        cursor: pointer;
    }

    .app-account:hover {
        color: var(--kob-ink-900);
    }

    .app-account vaadin-avatar {
        width: 28px;
        height: 28px;
    }

    .app-account vaadin-icon {
        width: 14px;
        height: 14px;
        color: var(--kob-ink-500);
    }

    .app-tabs {
        display: flex;
        align-items: center;
        gap: var(--kob-space-5);
    }

    .app-tab {
        padding: 14px 0;
        border-bottom: 2px solid transparent;
        font-size: 0.9rem;
        letter-spacing: 0.005em;
        color: var(--kob-ink-500);
        cursor: pointer;
        transition: color 0.15s ease;
    }

    .app-tab:hover {
        color: var(--kob-ink-800);
        text-decoration: none;
    }

    .app-tab.active {
        font-weight: 500;
        color: var(--kob-ink-900);
        border-bottom-color: var(--kob-orange-500);
    }

    .app-tabs-spacer {
        flex: 1;
    }

    .icon-link {
        display: inline-flex;
        color: var(--kob-ink-500);
        cursor: pointer;
        transition: color 0.15s ease;
    }

    .icon-link:hover {
        color: var(--kob-ink-900);
    }

    /* The bell is a button, not a link, so it needs the chrome stripped. */
    .icon-link.bell {
        position: relative;
        background: none;
        border: 0;
        padding: 0;
        font: inherit;
    }

    .bell-badge {
        position: absolute;
        top: -1px;
        right: -1px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: var(--kob-orange-500);
    }

    .icon-link svg,
    .icon-link vaadin-icon {
        width: 18px;
        height: 18px;
        color: inherit;
    }
  `
